/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { formatImportedAt } from '@/lib/formatting/dateTime';
import { useI18n } from '@/context/I18nContext';

interface SessionStatusCardsProps {
    accessToken: string
    requestStatus: string
    sessionImportedAt: string
    sessionStatus: string
}

function SessionStatusCards({
    accessToken,
    requestStatus,
    sessionImportedAt,
    sessionStatus,
}: SessionStatusCardsProps) {
    const { locale, t } = useI18n();

    return (
        <section className="dashboard-panel flex items-stretch justify-start p-5">
            <dl className="grid w-full grid-cols-1 gap-3 sm:grid-cols-3">
                <div className="min-w-0 rounded-box bg-base-200/60 px-3 py-2">
                    <dt className="text-xs font-semibold uppercase tracking-[0.08em] text-base-content/60">
                        {t('Session status')}
                    </dt>
                    <dd className="mt-1 break-words text-sm text-base-content">{sessionStatus}</dd>
                </div>

                <div className="min-w-0 rounded-box bg-base-200/60 px-3 py-2">
                    <dt className="text-xs font-semibold uppercase tracking-[0.08em] text-base-content/60">
                        {t('Current API token')}
                    </dt>
                    <dd className="mt-1 break-words text-sm text-base-content">
                        <span className="status-code">
                            {accessToken
                                ? `${accessToken.slice(0, 8)}…${accessToken.slice(-8)}`
                                : t('None')}
                        </span>
                        <span> </span>
                        <span>
                            ({formatImportedAt(
                                sessionImportedAt,
                                locale,
                                t('Unknown'),
                            )})
                        </span>
                    </dd>
                </div>

                <div className="min-w-0 rounded-box bg-base-200/60 px-3 py-2">
                    <dt className="text-xs font-semibold uppercase tracking-[0.08em] text-base-content/60">
                        {t('Request status')}
                    </dt>
                    <dd className="mt-1 break-words text-sm text-base-content">{requestStatus}</dd>
                </div>
            </dl>
        </section>
    );
}

export default SessionStatusCards;
